import React from "react";
import { Field, FieldProps } from "formik";
import { TextField, TextFieldProps } from "@mui/material";

type FormFieldProps = {
  name: string;
} & Omit<TextFieldProps, "name">;

/**
 * Reusable form field component that integrates Formik with Material-UI TextField
 * Automatically handles error display and touched state from Formik
 */
export default function FormField({ name, ...textFieldProps }: FormFieldProps) {
  return (
    <Field name={name}>
      {({ field, meta }: FieldProps) => (
        <TextField
          {...field}
          {...textFieldProps}
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error ? meta.error : textFieldProps.helperText}
          fullWidth
        />
      )}
    </Field>
  );
}
